import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { InfoDialogComponent } from '../../dialogs/info-dialog/info-dialog.component';
import { TipoMarcacaoEnum } from '../../enums/tipo-marcacao-enum';
import { ServicosUtilidadesService } from '../../servicos-utilidades/servicos-utilidades.service';

@Component({
  selector: 'app-enviar-comprovante-sms',
  templateUrl: './enviar-comprovante-sms.component.html',
  styleUrls: ['./enviar-comprovante-sms.component.css']
})
export class EnviarComprovanteSmsComponent implements OnInit {

  marcacao: any;

  formularioDeEnvioDeComprovantePorSMS: FormGroup;

  tipoMarcacao: TipoMarcacaoEnum = TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA;

  constructor(private servicosUtilidadesService: ServicosUtilidadesService, private router: Router,
    private formBuilder: FormBuilder, private dialog: MatDialog) {

    this.formularioDeEnvioDeComprovantePorSMS = this.formBuilder.group({
      foneCelular: ['', [Validators.required, Validators.minLength(16), Validators.maxLength(16)]]
    });
  }

  ngOnInit(): void {
    this.tipoMarcacao = history.state.tipoMarcacao;

    if ((this.tipoMarcacao as TipoMarcacaoEnum) === TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA) {
      this.marcacao = history.state.marcacaoConsulta;
    } else if ((this.tipoMarcacao as TipoMarcacaoEnum) === TipoMarcacaoEnum.TIPO_MARCACAO_EXAME) {
      this.marcacao = history.state.marcacaoProcedimento;
    }
  }

  onSubmit() {
    this.enviarComprovantePorSMS();
  }

  enviarComprovantePorSMS(): void {
    let foneCelular: string = this.formularioDeEnvioDeComprovantePorSMS.value.foneCelular;

    if (this.marcacao && this.marcacao.pk &&
      this.marcacao.pk.idPaciente && this.tipoMarcacao && foneCelular) {

      if ((this.tipoMarcacao as TipoMarcacaoEnum) === TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA) {

        this.servicosUtilidadesService.enviarSMSAgendamentoConsulta(this.marcacao, foneCelular)
          .subscribe(data => {
            // console.log(data)

            const dialogRef = this.dialog.open(InfoDialogComponent, {
              data: {
                title: 'Info',
                message: 'SMS enviado com sucesso!'
              }
            });

            dialogRef.afterClosed().subscribe(result => {
              this.marcacao.comprovanteSMSEnviado = true;
              this.router.navigate(['/marcacaoConsulta/marcacaoConsultaRealizada'], { state: { marcacaoConsulta: this.marcacao } });
            });
          }, error => {
            console.log(error);
          });
      } else if ((this.tipoMarcacao as TipoMarcacaoEnum) === TipoMarcacaoEnum.TIPO_MARCACAO_EXAME) {

        let local: string = this.getUnidade(this.marcacao.planoSaude.nome);

        this.servicosUtilidadesService.enviarSMSAgendamentoProcedimento(this.marcacao, foneCelular, environment.appAlias, local)
          .subscribe(data => {
            // console.log(data)

            const dialogRef = this.dialog.open(InfoDialogComponent, {
              data: {
                title: 'Info',
                message: 'SMS enviado com sucesso!'
              }
            });

            dialogRef.afterClosed().subscribe(result => {
              this.marcacao.comprovanteSMSEnviado = true;
              this.router.navigate(['/marcacaoConsulta/marcacaoProcedimentoRealizado'], { state: { marcacaoProcedimento: this.marcacao } });
            });
          }, error => {
            console.log(error);
          });
      } else {
        this.dialog.open(ErrorDialogComponent, {
          data: {
            title: 'Erro',
            message: 'Tipo de Marcação não encontrado!'
          }
        });
      }
    } else if (!foneCelular) {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Núm. Celular não encontrado!'
        }
      });
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Marcação não encontrada!'
        }
      });
    }
  }

  telaAnterior(): void {
    if ((this.tipoMarcacao as TipoMarcacaoEnum) === TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA) {
      this.router.navigate(['/marcacaoConsulta/marcacaoConsultaRealizada'], { state: { marcacaoConsulta: this.marcacao } });
    } else if ((this.tipoMarcacao as TipoMarcacaoEnum) === TipoMarcacaoEnum.TIPO_MARCACAO_EXAME) {
      this.router.navigate(['/marcacaoConsulta/marcacaoProcedimentoRealizado'], { state: { marcacaoProcedimento: this.marcacao } });
    }
  }

  getUnidade(nomePlanoSaude: string): string {
    return environment.appAlias != 'COPE_AGENDA' ? nomePlanoSaude : '-1';
  }
}
